/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const userProfile = {
  updateEmailForm: {
    newEmailAddress: {
      label: 'Nueva dirección de correo electrónico',
      placeholder: 'Ingrese el correo electrónico',
    },
    confirmNewEmailAddress: {
      label: 'Confirmar nueva dirección de correo electrónico',
      placeholder: 'Ingrese el correo electrónico',
    },
    enterValidEmail: 'Por favor, introduzca un correo electrónico válido.',
    bothEmailMustMatch: 'Ambos correos electrónicos deben coincidir',
    password: {
      label: 'Contraseña',
      placeholder: 'Introduzca la contraseña',
    },
    pleaseInputPassword: 'Por favor, introduzca la contraseña',
    emailUpdateSuccess: 'Éxito. Por favor, inicie sesión con {{ newUid }}',
  },
  register: {
    confirmPassword: {
      action: 'Confirmar contraseña',
      label: 'Confirmar contraseña',
      placeholder: 'Confirm Contraseña',
    },
    managementInMyAccount: 'Gestión en Mi Cuenta.',
    termsAndConditions: 'Términos y condiciones',
    signIn: 'Ya tengo una cuenta. Inicia sesión',
    register: 'Registro',
    confirmNewPassword: 'Confirm New Contraseña',
    resetPassword: 'Restablecer Contraseña',
    createAccount: 'Crear una cuenta',
    title: 'Título',
    firstName: {
      label: 'Nombre',
      placeholder: 'Nombre',
    },
    lastName: {
      label: 'Apellido',
      placeholder: 'Apellido',
    },
    emailAddress: {
      label: 'Dirección de correo electrónico',
      placeholder: 'Dirección de correo electrónico',
    },
    password: {
      label: 'Contraseña',
      placeholder: 'Contraseña',
    },
    newPassword: 'Nueva Contraseña',
    emailMarketing:
      'Utilizar mis datos personales para recibir boletines informativos por correo electrónico para campañas de marketing. Para cambiar tu configuración, ve a Consentimiento Gestión en Mi Cuenta.',
    confirmThatRead: 'Confirmo que he leído y estoy de acuerdo con el',
    selectTitle: 'Select Título',
    passwordMinRequirements:
      'La contraseña debe tener un mínimo de seis caracteres, con una letra mayúscula, un número y un símbolo',
    bothPasswordMustMatch: 'Ambas contraseñas deben coincidir',
    titleRequired: 'Se requiere título.',
    postRegistroMessage: 'Inicie sesión con las credenciales proporcionadas.',
  },
  forgottenPassword: {
    resetPassword: 'Restablecer contraseña',
    enterEmailAddressAssociatedWithYourAccount:
      'Ingresa la dirección de correo electrónico asociada a tu cuenta',
    emailAddress: {
      label: 'Dirección de correo electrónico',
      placeholder: 'Ingrese el correo electrónico',
    },
    enterValidEmail: 'Por favor, introduzca un correo electrónico válido.',
    passwordResetEmailSent:
      'Se le ha enviado un correo electrónico con información sobre cómo restablecer su contraseña.',
    passwordResetSuccess: 'Success! You can now login using your new password.',
  },
};
